import { render, staticRenderFns } from "./DateFieldReadonly.vue?vue&type=template&id=76bfb1b2&scoped=true"
import script from "./DateFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./DateFieldReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bfb1b2",
  null
  
)

export default component.exports